// extracted by mini-css-extract-plugin
module.exports =  {"page":"_734d14f77d--page--ZjufT","text":"_734d14f77d--text--dw5Qk","button":"_734d14f77d--button--fOt8h"};